{
	"title": "Gestionează declarațiile",
	"createDeclaration": "Creează declarație"
}
